import { ProductFormValues } from './types';

export const PRODUCT_TAGS = [
    'สินค้าหลัก',
    'ดีลพิเศษ',
    'เซ็ตสุดคุ้ม',
    'HYB_Exclusive',
    'Premium_Line',
    'ขายดีประจำเดือน',
    'สินค้าใหม่ล่าสุด',
    'สินค้าลดแรง',
    'สินค้าแนะนำ',
] as const;

export const defaultFormValues: ProductFormValues = {
    name: '',
    description: '',
    price: 0,
    salePrice: null,
    isOnSale: false,
    categoryId: '',
    tags: [],
    soldCount: 0,
    images: [],
    warehouse: 'HYB',
    variants: [],
};

export const resolveProductImage = (
    image: any | undefined,
    preferredSize: 'thumbnail' | 'medium' | 'large' = 'thumbnail',
): string => {
    if (!image) {
        return '';
    }

    if (typeof image === 'string') {
        return image;
    }

    return image[preferredSize] ?? image.large ?? image.medium ?? image.thumbnail ?? '';
};
